import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { CountryCard } from "@/components/CountryDossiers";
import { COUNTRIES } from "@/data/content";

export default function CountriesPage() {
  return (
    <main data-testid="countries-page">
      <PageHero
        kicker="Country Dossiers"
        title="Evidence-Rich Country Profiles"
        copy="Country profiles combining development priorities, institutions, policy context, story leads and partnership opportunities — built for journalists, researchers and institutions."
      />
      <section className="bg-sand py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="mb-12 flex flex-col gap-4 border border-gold/40 bg-sand-dark p-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="max-w-2xl text-sm leading-relaxed text-slate-600">
              Full dossiers are published progressively, as research is completed and verified. The Jamaica Country
              Dossier is the first in the series; the Ghana dossier is in active development.
            </p>
            <Link
              data-testid="countries-jamaica-cta"
              to="/countries/jamaica"
              className="group inline-flex shrink-0 items-center gap-2 bg-atlantic px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-atlantic-light"
            >
              Open the Jamaica Dossier
              <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {COUNTRIES.map((c) => (
              <CountryCard key={c.slug} country={c} />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
